import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, lazy, Suspense, Fragment } from 'react';
import PropTypes from 'prop-types';
import ProjectSummary from '../ProjectSummary';
import ProjectSidebar from './ProjectSidebar';
import { getRequest } from '../../requestUtils';
import Loading from '../common/Loading';
import './ProjectNav.scss';
import { analyticsTrack } from '../../analyticsUtils';
import { PROJECT_RECOMMENDED_TAB_LOCATION } from '../../constants';

// lazy lets you defer loading component’s code until it is rendered for the first time.
var ProjectProposalsTab = /*#__PURE__*/lazy(function () {
  return import('../ProjectProposalsTab');
});
var ProjectProposalReviewTab = /*#__PURE__*/lazy(function () {
  return import('../ProjectProposalReviewTab');
});
var AlgoliaInstantSearch = /*#__PURE__*/lazy(function () {
  return import('../FeaturedProfiles/AlgoliaInstantSearch');
});
var ScreeningQuestions = /*#__PURE__*/lazy(function () {
  return import('./ScreeningQuestions');
});
var ConsultantComparison = /*#__PURE__*/lazy(function () {
  return import('./ConsultantComparison');
});
var MOBILE_PRIMARY_COUNT = 2;

// The 'proposals' tab is the full internal application pipeline, labeled "Applications" and
// always shown to Clora reps. Employers only get it (labeled "Proposals", the pre-rollout scope
// and copy) until 'proposal_review_tab' is enabled for them - once showProposalReviewTab is true,
// they use 'proposal-review' ("Proposal Review") instead and this tab disappears for them.
var tabs = function tabs(showConsultantComparisonTab, cloraRep, showProposalReviewTab) {
  var tabsArray = [];
  if (cloraRep) {
    tabsArray.push({
      key: 'proposals',
      label: 'Applications',
      mobileLabel: 'Applications'
    });
  } else if (!showProposalReviewTab) {
    tabsArray.push({
      key: 'proposals',
      label: 'Proposals',
      mobileLabel: 'Proposals'
    });
  }
  if (showProposalReviewTab) tabsArray.push({
    key: 'proposal-review',
    label: 'Proposal Review',
    mobileLabel: 'Review'
  });
  tabsArray.push({
    key: 'recommended',
    label: 'Recommended Consultants',
    mobileLabel: 'Recommended'
  }, {
    key: 'details',
    label: 'Project Details',
    mobileLabel: 'Project Details'
  });
  if (showConsultantComparisonTab) tabsArray.push({
    key: 'comparison',
    label: 'Consultant Comparison',
    mobileLabel: 'Comparison'
  });
  tabsArray.push({
    key: 'screening',
    label: 'Screening Questions',
    mobileLabel: 'Screening'
  });
  if (cloraRep) tabsArray.push({
    key: 'pdf-preview',
    label: 'PDF Preview',
    mobileLabel: 'PDF Preview'
  });
  return tabsArray;
};
var ProjectNav = /*#__PURE__*/function (_Component) {
  function ProjectNav(props) {
    var _this;
    _classCallCheck(this, ProjectNav);
    _this = _callSuper(this, ProjectNav, [props]);
    var showConsultantComparisonTab = props.showConsultantComparisonTab,
      cloraRep = props.cloraRep,
      showProposalReviewTab = props.showProposalReviewTab;
    var tabList = tabs(showConsultantComparisonTab, cloraRep, showProposalReviewTab);

    // Get tab from URL or default to 'details'
    var urlParams = new URLSearchParams(window.location.search);
    var indexParam = urlParams.get('tab');
    var defaultTab = tabList.find(function (tab) {
      return tab.key === indexParam;
    }) ? indexParam : 'details';
    _this.state = {
      selectedTab: defaultTab,
      project: null,
      nextStepsData: props.nextStepsData,
      moreMenuOpen: false
    };
    _this.clickTab = _this.clickTab.bind(_this);
    _this.renderTab = _this.renderTab.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    _this.updateNextSteps = _this.updateNextSteps.bind(_this);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.moreMenuRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(ProjectNav, _Component);
  return _createClass(ProjectNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.fetchProjectData();
      document.addEventListener('mousedown', this.handleOutsideClick);

      // Show inline Project PDF preview on initial load if tab=pdf-preview
      try {
        var prev = document.getElementById('project-pdf-preview-inline');
        if (prev && this.state.selectedTab === 'pdf-preview') {
          prev.classList.remove('d-none');
        }
      } catch (e) {/* noop */}

      // Handle browser navigation to keep tab and preview in sync
      this._onPopState = function () {
        try {
          var urlParams = new URLSearchParams(window.location.search);
          var tab = urlParams.get('tab') || 'details';
          _this2.setState({
            selectedTab: tab
          });
          var _prev = document.getElementById('project-pdf-preview-inline');
          if (_prev) {
            if (tab === 'pdf-preview') _prev.classList.remove('d-none');else _prev.classList.add('d-none');
          }
        } catch (e) {/* noop */}
      };
      window.addEventListener('popstate', this._onPopState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._onPopState) window.removeEventListener('popstate', this._onPopState);
      document.removeEventListener('mousedown', this.handleOutsideClick);
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(e) {
      if (this.moreMenuRef.current && !this.moreMenuRef.current.contains(e.target)) {
        this.setState({
          moreMenuOpen: false
        });
      }
    }
  }, {
    key: "fetchProjectData",
    value: function fetchProjectData() {
      var _this3 = this;
      var projectResourceId = this.props.projectResourceId;
      getRequest("/projects/".concat(projectResourceId), {
        form_step: 'review'
      }).then(function (response) {
        _this3.setState({
          project: response.data
        });
      });
    }
  }, {
    key: "clickTab",
    value: function clickTab(tabKey) {
      var selectedTab = this.state.selectedTab;
      var url = new URL(window.location);

      // Only clear consultants if you are LEAVING the comparison tab
      if (selectedTab === 'comparison' && tabKey !== 'comparison') {
        url.searchParams["delete"]('consultants_Ids');
      }
      url.searchParams.set('tab', tabKey);
      window.history.pushState({}, '', url);

      // Toggle inline Project PDF preview visibility
      try {
        var prev = document.getElementById('project-pdf-preview-inline');
        if (prev) {
          if (tabKey === 'pdf-preview') prev.classList.remove('d-none');else prev.classList.add('d-none');
        }
      } catch (e) {/* noop */}
      this.setState({
        selectedTab: tabKey
      });
    }
  }, {
    key: "projectFilters",
    value: function projectFilters() {
      var project = this.state.project;
      if (!project) return {};
      return {
        refinementList: {
          'area_of_expertises.name': project.area_of_expertises.map(function (aoe) {
            return aoe.name;
          }),
          'therapeutic_areas.name': project.therapeutic_areas.map(function (ta) {
            return ta.name;
          }).filter(function (name) {
            return project.priority_expertise_tags.includes(name);
          }),
          'therapies.name': project.therapies.map(function (th) {
            return th.name;
          }).filter(function (name) {
            return project.priority_expertise_tags.includes(name);
          }),
          'higher_level_roles.name': project.higher_level_roles.map(function (hlr) {
            return hlr.name;
          }).filter(function (name) {
            return project.priority_expertise_tags.includes(name);
          }),
          development_phases: project.development_phases.map(function (ph) {
            return ph.name;
          }).filter(function (name) {
            return project.priority_expertise_tags.includes(name);
          }),
          seniority_levels: project.seniority.filter(function (name) {
            return project.priority_expertise_tags.includes(name);
          })
        }
      };
    }
  }, {
    key: "updateNextSteps",
    value: function updateNextSteps() {
      var _this4 = this;
      var nextStepsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (nextStepsData !== null) {
        this.setState({
          nextStepsData: nextStepsData
        });
      } else {
        var projectResourceId = this.props.projectResourceId;
        getRequest("/projects/".concat(projectResourceId, "/next_steps")).then(function (_ref) {
          var data = _ref.data;
          _this4.setState({
            nextStepsData: data
          });
        });
      }
    }
  }, {
    key: "renderTab",
    value: function renderTab(tab, tabIndex) {
      var _this5 = this;
      var mobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var selectedTab = this.state.selectedTab;
      var projectStatus = this.props.projectStatus;
      var isSelected = selectedTab === tab.key;
      var isRecommendedTabHidden = tab.key === 'recommended' && !['employer_draft', 'clora_matching', 'employer_requested_matching'].includes(projectStatus);
      var hideTab = isRecommendedTabHidden ? 'd-none' : '';
      return /*#__PURE__*/React.createElement("a", {
        role: "button",
        className: "body-text-2 medium-weight tab-active-".concat(isSelected, " ").concat(hideTab),
        onClick: function onClick() {
          _this5.clickTab(tab.key);
          _this5.setState({
            moreMenuOpen: false
          });
          if (tab.key === 'recommended') {
            analyticsTrack('Viewed recommended consultants tab');
          }
        },
        key: tab.key,
        tabIndex: tabIndex
      }, mobile ? tab.mobileLabel || tab.label : tab.label);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        csrfToken = _this$props.csrfToken,
        ownerOrCloraRep = _this$props.ownerOrCloraRep,
        projectId = _this$props.projectId,
        cloraRep = _this$props.cloraRep,
        showPublishedModal = _this$props.showPublishedModal,
        userType = _this$props.userType,
        projectPermissionLevel = _this$props.projectPermissionLevel,
        initialTeamMembers = _this$props.initialTeamMembers,
        invitableRoles = _this$props.invitableRoles,
        editableRoles = _this$props.editableRoles,
        basePermissionsUrl = _this$props.basePermissionsUrl,
        invitedColleagues = _this$props.invitedColleagues,
        coworkersModalIsOpen = _this$props.coworkersModalIsOpen,
        reps = _this$props.reps,
        shareOptions = _this$props.shareOptions,
        shareRecipientOptions = _this$props.shareRecipientOptions,
        proposalShareRecipientOptions = _this$props.proposalShareRecipientOptions,
        salesBookingLink = _this$props.salesBookingLink,
        invitationsCount = _this$props.invitationsCount,
        invitedFeedback = _this$props.invitedFeedback,
        colleagues = _this$props.colleagues,
        currentUserEmail = _this$props.currentUserEmail,
        permissions = _this$props.permissions,
        cloraEmployer = _this$props.cloraEmployer,
        indexName = _this$props.indexName,
        agAppID = _this$props.agAppID,
        publicKey = _this$props.publicKey,
        userData = _this$props.userData,
        showProjectEmploymentType = _this$props.showProjectEmploymentType,
        inviterId = _this$props.inviterId,
        projectsOptions = _this$props.projectsOptions,
        searchUrl = _this$props.searchUrl,
        isCollaborator = _this$props.isCollaborator,
        cloraRepName = _this$props.cloraRepName,
        consultants = _this$props.consultants,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl,
        signInUrl = _this$props.signInUrl,
        createInterviewUrl = _this$props.createInterviewUrl,
        availableInterviewSlotUrl = _this$props.availableInterviewSlotUrl,
        hiddenFeedbackOptions = _this$props.hiddenFeedbackOptions,
        visibleFeedbackOptions = _this$props.visibleFeedbackOptions,
        consultantFeedbackOptions = _this$props.consultantFeedbackOptions;
      var _this$state = this.state,
        project = _this$state.project,
        selectedTab = _this$state.selectedTab;
      switch (selectedTab) {
        case 'proposals':
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(ProjectProposalsTab, {
            cloraRep: cloraRep,
            projectId: projectId,
            projectResourceId: projectResourceId,
            csrfToken: csrfToken,
            projectsOptions: projectsOptions,
            searchUrl: searchUrl,
            isCollaborator: isCollaborator,
            cloraRepName: cloraRepName
          }));
        case 'proposal-review':
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(ProjectProposalReviewTab, {
            projectResourceId: projectResourceId,
            csrfToken: csrfToken,
            cloraRep: cloraRep,
            initialTeamMembers: initialTeamMembers,
            invitableRoles: invitableRoles,
            createInterviewUrl: createInterviewUrl,
            availableInterviewSlotUrl: availableInterviewSlotUrl,
            hiddenFeedbackOptions: hiddenFeedbackOptions,
            visibleFeedbackOptions: visibleFeedbackOptions,
            consultantFeedbackOptions: consultantFeedbackOptions,
            projectsOptions: projectsOptions,
            sourceOptions: shareOptions,
            recipientOptions: proposalShareRecipientOptions,
            basePermissionsUrl: basePermissionsUrl,
            editableRoles: editableRoles,
            currentUserEmail: currentUserEmail
          }));
        case 'recommended':
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(AlgoliaInstantSearch, {
            indexName: indexName,
            agAppID: agAppID,
            publicKey: publicKey,
            handleRegister: this.handleUserSignUp,
            csrfToken: csrfToken,
            userData: userData,
            getEmailStatus: function getEmailStatus() {
              return userData && userData.email;
            },
            cloraEmployer: cloraEmployer,
            initialFilters: this.projectFilters(),
            projectResourceId: projectResourceId,
            location: PROJECT_RECOMMENDED_TAB_LOCATION,
            googleOmniauthUrl: googleOmniauthUrl,
            msOmniauthUrl: msOmniauthUrl,
            signInUrl: signInUrl,
            inviterId: inviterId
          }));
        case 'screening':
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(ScreeningQuestions, {
            csrfToken: csrfToken,
            projectId: projectId,
            updateNextSteps: this.updateNextSteps
          }));
        case 'comparison':
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement(Loading, null)
          }, /*#__PURE__*/React.createElement(ConsultantComparison, {
            consultants: consultants || [],
            projectResourceId: projectResourceId
          }));
        case 'pdf-preview':
          // Inline server-rendered preview is placed in the Rails view; show note in content area
          return /*#__PURE__*/React.createElement("div", null);
        default:
          return /*#__PURE__*/React.createElement(ProjectSummary, {
            project: project,
            projectResourceId: projectResourceId,
            csrfToken: csrfToken,
            permissions: permissions,
            projectPermissionLevel: projectPermissionLevel,
            ownerOrCloraRep: ownerOrCloraRep,
            showPublishedModal: showPublishedModal,
            userType: userType,
            initialTeamMembers: initialTeamMembers,
            invitableRoles: invitableRoles,
            editableRoles: editableRoles,
            basePermissionsUrl: basePermissionsUrl,
            coworkersModalIsOpen: coworkersModalIsOpen,
            reps: reps,
            shareOptions: shareOptions,
            shareRecipientOptions: shareRecipientOptions,
            salesBookingLink: salesBookingLink,
            invitationsCount: invitationsCount,
            invitedColleages: invitedColleagues,
            invitedFeedback: invitedFeedback,
            colleagues: colleagues,
            currentUserEmail: currentUserEmail,
            showProjectEmploymentType: showProjectEmploymentType,
            updateNextSteps: this.updateNextSteps,
            isCollaborator: isCollaborator
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
        _tabList$find;
      var _this$props2 = this.props,
        userType = _this$props2.userType,
        projectPermissionLevel = _this$props2.projectPermissionLevel,
        csrfToken = _this$props2.csrfToken,
        initialTeamMembers = _this$props2.initialTeamMembers,
        editableRoles = _this$props2.editableRoles,
        basePermissionsUrl = _this$props2.basePermissionsUrl,
        coworkersModalIsOpen = _this$props2.coworkersModalIsOpen,
        reps = _this$props2.reps,
        shareOptions = _this$props2.shareOptions,
        shareRecipientOptions = _this$props2.shareRecipientOptions,
        salesBookingLink = _this$props2.salesBookingLink,
        invitationsCount = _this$props2.invitationsCount,
        invitedColleagues = _this$props2.invitedColleagues,
        colleagues = _this$props2.colleagues,
        currentUserEmail = _this$props2.currentUserEmail,
        projectResourceId = _this$props2.projectResourceId,
        invitableRoles = _this$props2.invitableRoles,
        acceptedProposal = _this$props2.acceptedProposal,
        review = _this$props2.review,
        authUserCanSeeProposal = _this$props2.authUserCanSeeProposal,
        showHireAgain = _this$props2.showHireAgain,
        showHourlyRate = _this$props2.showHourlyRate,
        googleOmniauthUrl = _this$props2.googleOmniauthUrl,
        cloraRep = _this$props2.cloraRep,
        msOmniauthUrl = _this$props2.msOmniauthUrl,
        signInUrl = _this$props2.signInUrl,
        inviterId = _this$props2.inviterId,
        showConsultantComparisonTab = _this$props2.showConsultantComparisonTab,
        showProposalReviewTab = _this$props2.showProposalReviewTab;
      var _this$state2 = this.state,
        selectedTab = _this$state2.selectedTab,
        project = _this$state2.project,
        nextStepsData = _this$state2.nextStepsData,
        moreMenuOpen = _this$state2.moreMenuOpen;
      var tabList = tabs(showConsultantComparisonTab, cloraRep, showProposalReviewTab);
      var primaryTabs = tabList.slice(0, MOBILE_PRIMARY_COUNT);
      var overflowTabs = tabList.slice(MOBILE_PRIMARY_COUNT);
      var overflowHasActive = overflowTabs.some(function (t) {
        return t.key === selectedTab;
      });
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "container-fluid bg-white project-tabs-container px-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container d-none d-xl-flex gap-4 project-tabs pb-0"
      }, tabList.map(function (tab, i) {
        return _this6.renderTab(tab, i);
      })), /*#__PURE__*/React.createElement("div", {
        className: "container d-flex d-xl-none project-tabs-mobile pb-0"
      }, primaryTabs.map(function (tab, i) {
        return _this6.renderTab(tab, i, true);
      }), overflowTabs.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "more-tabs-wrapper ".concat(overflowHasActive ? 'more-tabs-wrapper--active' : ''),
        ref: this.moreMenuRef
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "more-tabs-btn body-text-2 medium-weight tab-active-".concat(overflowHasActive),
        onClick: function onClick() {
          return _this6.setState({
            moreMenuOpen: !moreMenuOpen
          });
        },
        "aria-haspopup": "menu",
        "aria-expanded": moreMenuOpen,
        "aria-controls": "project-tabs-more-menu"
      }, overflowHasActive ? ((_tabList$find = tabList.find(function (t) {
        return t.key === selectedTab;
      })) === null || _tabList$find === void 0 ? void 0 : _tabList$find.mobileLabel) || 'More' : 'More', ' ', moreMenuOpen ? '▴' : '▾'), moreMenuOpen && /*#__PURE__*/React.createElement("div", {
        className: "more-tabs-menu",
        id: "project-tabs-more-menu",
        role: "menu"
      }, overflowTabs.map(function (tab, i) {
        return _this6.renderTab(tab, MOBILE_PRIMARY_COUNT + i, true);
      }))))), /*#__PURE__*/React.createElement("div", {
        id: projectResourceId,
        className: selectedTab !== 'pdf-preview' ? 'g-row project-content container project-container style-guide mt-4' : 'd-none'
      }, this.renderContent(), !['recommended', 'comparison', 'pdf-preview', 'proposal-review'].includes(selectedTab) && project ? /*#__PURE__*/React.createElement(ProjectSidebar, {
        project: project,
        userType: userType,
        projectPermissionLevel: projectPermissionLevel,
        csrfToken: csrfToken,
        initialTeamMembers: initialTeamMembers,
        invitableRoles: invitableRoles,
        editableRoles: editableRoles,
        basePermissionsUrl: basePermissionsUrl,
        coworkersModalIsOpen: coworkersModalIsOpen,
        reps: reps,
        shareOptions: shareOptions,
        shareRecipientOptions: shareRecipientOptions,
        salesBookingLink: salesBookingLink,
        invitationsCount: invitationsCount,
        invitedColleagues: invitedColleagues,
        colleagues: colleagues,
        currentUserEmail: currentUserEmail,
        acceptedProposal: acceptedProposal,
        review: review,
        authUserCanSeeProposal: authUserCanSeeProposal,
        showHireAgain: showHireAgain,
        showHourlyRate: showHourlyRate,
        nextStepsData: nextStepsData,
        clickTab: this.clickTab,
        projectResourceId: projectResourceId,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        signInUrl: signInUrl,
        inviterId: inviterId
      }) : ''));
    }
  }]);
}(Component);
ProjectNav.propTypes = {
  cloraRep: PropTypes.bool.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectStatus: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  permissions: PropTypes.shape({}),
  ownerOrCloraRep: PropTypes.bool,
  showPublishedModal: PropTypes.bool,
  userType: PropTypes.string.isRequired,
  projectPermissionLevel: PropTypes.string,
  initialTeamMembers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  createInterviewUrl: PropTypes.string,
  availableInterviewSlotUrl: PropTypes.string,
  hiddenFeedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  visibleFeedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  consultantFeedbackOptions: PropTypes.arrayOf(PropTypes.shape({})),
  basePermissionsUrl: PropTypes.string.isRequired,
  coworkersModalIsOpen: PropTypes.bool,
  reps: PropTypes.arrayOf(PropTypes.shape({})),
  shareOptions: PropTypes.arrayOf(PropTypes.shape({})),
  shareRecipientOptions: PropTypes.arrayOf(PropTypes.shape({})),
  proposalShareRecipientOptions: PropTypes.arrayOf(PropTypes.shape({})),
  salesBookingLink: PropTypes.string,
  invitationsCount: PropTypes.number,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedFeedback: PropTypes.shape({}),
  colleagues: PropTypes.arrayOf(PropTypes.shape({})),
  currentUserEmail: PropTypes.string,
  authUserCanSeeProposal: PropTypes.bool,
  acceptedProposal: PropTypes.shape({}),
  review: PropTypes.shape({}),
  showHourlyRate: PropTypes.bool,
  showHireAgain: PropTypes.bool,
  indexName: PropTypes.string.isRequired,
  agAppID: PropTypes.string.isRequired,
  publicKey: PropTypes.string.isRequired,
  cloraEmployer: PropTypes.bool,
  userData: PropTypes.shape({}),
  nextStepsData: PropTypes.shape({}),
  showProjectEmploymentType: PropTypes.bool,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  inviterId: PropTypes.string,
  searchUrl: PropTypes.string,
  cloraRepName: PropTypes.string,
  projectsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tabSelected: PropTypes.string,
  showProposalReviewTab: PropTypes.bool
};
ProjectNav.defaultProps = {
  permissions: {},
  projectPermissionLevel: null,
  ownerOrCloraRep: false,
  showPublishedModal: false,
  reps: [],
  shareOptions: [],
  shareRecipientOptions: [],
  proposalShareRecipientOptions: [],
  salesBookingLink: null,
  invitationsCount: 0,
  invitedColleagues: [],
  invitedFeedback: null,
  currentUserEmail: null,
  initialTeamMembers: {},
  invitableRoles: [],
  editableRoles: [],
  createInterviewUrl: '',
  availableInterviewSlotUrl: '',
  hiddenFeedbackOptions: [],
  visibleFeedbackOptions: [],
  consultantFeedbackOptions: [],
  coworkersModalIsOpen: false,
  colleagues: [],
  authUserCanSeeProposal: false,
  review: {},
  showHourlyRate: false,
  showHireAgain: false,
  acceptedProposal: null,
  tabSelected: '2',
  cloraEmployer: false,
  userData: {},
  nextStepsData: {},
  showProjectEmploymentType: false,
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  inviterId: null,
  searchUrl: '',
  cloraRepName: 'Clora Rep',
  showProposalReviewTab: false
};
export default ProjectNav;